import { call, put, select, takeLatest } from "redux-saga/effects";
import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { dummyStructure } from "../../../features/Landing/dummy/quickMenu";

// Initial state
const initialState = {
  loading: false,
  loaded: null,
  error: false,
  data: null,
  menuItems: [],
};

// Slice
const quickMenuSlice = createSlice({
  name: "quickMenu",
  initialState,
  reducers: {
    getQuickMenu(state) {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    },
    initQuickMenu(state) {
      return {
        ...state,
        menuItems: [],
      };
    },
    setQuickMenu(state, action) {
      const { data } = action.payload;
      return {
        ...state,
        menuItems: data,
      };
    },
    fetchDataSuccess(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: false,
        loaded: true,
      };
    },
    fetchDataFailure(state, action) {
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: action.payload,
        loaded: true,
      };
    },
  },
});

export const {
  getQuickMenu,
  initQuickMenu,
  setQuickMenu,
  fetchDataSuccess,
  fetchDataFailure,
} = quickMenuSlice.actions;

export default quickMenuSlice.reducer;

//saga
function* fetchDataSaga(action) {
  const peerIp = yield select((state) => state.peerIp.ip);
  try {
    const { headers = {}, apiUrl, data } = action.payload;
    const apiService = axios.create({
      headers: {
        ...headers,
        user_ip: peerIp
      }
    });
    const response = yield call(apiService.post, apiUrl, data);
    // const response = dummyStructure;

    yield put(fetchDataSuccess(response.data));
    // const menuItems = dummyStructure;
    // const response = menuItems;
    if (response?.data) {
      const { code, count, data } = response.data;
      if (code === "0200") {
        yield put(
          setQuickMenu({
            data,
          })
        );
      }
    }
  } catch (error) {
    yield put(fetchDataFailure(error));
  }
}

// API 호출을 감시하는 Saga 함수
export function* quickMenuSaga() {
  yield takeLatest(getQuickMenu.type, fetchDataSaga);
}
